// extracted by mini-css-extract-plugin
export var featured = "featured-module--featured--26_eX";
export var featuredProject = "featured-module--featuredProject--54XpB";
export var name = "featured-module--name--3VTbA";
export var description = "featured-module--description--2G0No";
export var additional = "featured-module--additional--1C55Q";
export var imageStyle = "featured-module--imageStyle--2HhvR";